define(['jquery', 'moment', 'jquery-ui/jquery-ui'], function($, moment) {
    function ShippingCalendar(options) {
        this.options = options || {};
        this.parent = this.options.parent || {};
        this.selectDriven = this.options.selectDriven || false;
    }

    ShippingCalendar.prototype = {
        init: function(options) {
            var params = {
                deliveryDates: {},
                minDate: new Date()
            };
            var shipDateArr = [];

            options = options || {};

            this.$calendar = options.$calendar;
            this.$ulDelivery = options.$ulDelivery;

            if (this.isInitialized) {
                this.destroy();
            }

            if (this.selectDriven) {
                this.$ulDelivery.find('option').each(
                    function(index, element) {
                        var shipDate;
                        var $element = $(element);
                        var date = $element.data('date');

                        if (date !== undefined) {
                            shipDate = moment(date, 'MM/DD/YYYY');
                        } else {
                            shipDate = moment();
                        }

                        var value = $($.parseHTML($element.data('text')))
                            .filter('em')
                            .text();
                        value = this.formatStr(value);

                        shipDateArr.push(shipDate);
                        params.deliveryDates[shipDate.toDate()] = [shipDate.format('ddd MMMM DD YYYY'), value];
                    }.bind(this)
                );
            } else {
                this.$ulDelivery.find('li').each(function(index, element) {
                    var $li = $(element);
                    var date = $li.find('input').data('date');
                    var shipDate = moment(date, 'MM/DD/YYYY');
                    var value = $li
                        .find('em > abbr, .norm')
                        .prepend(' ')
                        .text();

                    shipDateArr.push(shipDate);
                    params.deliveryDates[shipDate.toDate()] = [shipDate.format('ddd MMMM DD YYYY'), value];
                });
            }

            params.maxDate = moment.max(shipDateArr).toDate();

            if (this.options.clickable) {
                this.initClickableCalendar(params);
            } else {
                this.initSimpleCalendar(params);
            }

            this.initEvents();

            if (this.parent.shipMethod) {
                if (this.selectDriven) {
                    this.$ulDelivery.val(this.parent.shipMethod).trigger('change');
                } else {
                    this.$ulDelivery
                        .find('input')
                        .eq(this.parent.shipMethod)
                        .prop('checked', true)
                        .trigger('change');
                }
            }

            this.$calendar.datepicker('setDate', $('input[name=shipdel]:checked').data('date'));
            this.isInitialized = true;
        },

        initEvents: function() {
            var _this = this;

            if (this.selectDriven) {
                this.$ulDelivery.on('change', function() {
                    _this.$calendar.datepicker(
                        'setDate',
                        $(this)
                            .find('option:selected')
                            .data('date')
                    );
                });
            } else {
                this.$ulDelivery.on('change', 'input[type=radio]', function() {
                    _this.$calendar.datepicker('setDate', $(this).data('date'));
                });
            }
        },

        // Simple Shipping Calendar:
        initSimpleCalendar: function(params) {
            this.setCalendarDisplay(params);
        },

        // Clickable Shipping Calendar:
        initClickableCalendar: function(params) {
            var _this = this,
                handlers = {
                    beforeShowDay: function setDeliveryDays(date, test) {
                        var deliveryDates = params && params.deliveryDates;

                        for (var key in deliveryDates) {
                            if (deliveryDates.hasOwnProperty(key) && date == key) {
                                return [true, 'delivery', deliveryDates[key].toString()];
                            }
                        }

                        return [false, ''];
                    },
                    onSelect: function(dateText, inst) {
                        if (_this.parent.loading) {
                            return;
                        }

                        var $deliveryOption = _this.findDeliveryOptionByDate(dateText);

                        if (_this.selectDriven) {
                            $deliveryOption.prop('selected', true);
                            _this.$ulDelivery.trigger('change');
                        } else {
                            $deliveryOption.prop('checked', true).trigger('change');
                        }
                    }
                };

            _this.setCalendarDisplay(params, handlers);

            $('.ship-msg').show();
        },

        setCalendarDisplay: function(params, handlers) {
            params = params || {};
            handlers = handlers || {};
            var minDate = moment(params.minDate);
            var maxDate = moment(params.maxDate);
            var numberOfMonths;

            if (this.options.showAllAvailableMonths) {
                numberOfMonths = maxDate.month() - minDate.month() + 1;
            }

            this.$calendar.datepicker({
                minDate: params.minDate ? minDate.toDate() : 0,
                maxDate: params.maxDate ? maxDate.toDate() : 31,
                numberOfMonths: numberOfMonths || 1,
                showOtherMonths: true,
                dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
                // event handlers:
                onSelect: handlers.onSelect,
                beforeShowDay:
                    handlers.beforeShowDay ||
                    function() {
                        return [false, ''];
                    }
            });
        },

        destroy: function() {
            if (this.$calendar) {
                this.$calendar.datepicker('destroy');
            }

            this.isInitialized = false;
        },

        // Helpers:
        formatStr: function(str) {
            return String(str)
                .replace(/[\r\n]+/gm, '')
                .replace(/ +/g, ' ')
                .trim()
                .valueOf();
        },

        findDeliveryOptionByDate: function(dateText) {
            var address, $deliveryOption;
            var $deliveryOptions = this.$ulDelivery.find('[data-date="' + dateText + '"]');

            if (this.selectDriven) {
                address = this.$ulDelivery.find(':selected').data('address');
            } else {
                address = this.$ulDelivery.find(':checked').data('address');
            }

            if (address) {
                $deliveryOption = $deliveryOptions.filter('[data-address="' + address + '"]');
            }

            if (!($deliveryOption && $deliveryOption.length)) {
                $deliveryOption = $deliveryOptions.first();
            }

            return $deliveryOption;
        }
    };

    return ShippingCalendar;
});
